<template>
  <section class="strong-g">
    <slot />
  </section>
</template>

<style scoped>
/* 強グループ同士のマージンは24pxデフォルト */
.strong-g:not(:first-of-type) {
  margin-top: var(--base-24px);
}

.strong-g:deep(.t-4px) {
  margin-top: var(--base-4px);
}

.strong-g:deep(.l-4px) {
  margin-left: var(--base-4px);
}

.strong-g:deep(.t-8px) {
  margin-top: var(--base-8px);
}

.strong-g:deep(.l-8px) {
  margin-left: var(--base-8px);
}

.strong-g:deep(.t-12px) {
  margin-top: var(--base-12px);
}

.strong-g:deep(.l-12px) {
  margin-left: var(--base-12px);
}

.strong-g:deep(.t-16px) {
  margin-top: var(--base-16px);
}

.strong-g:deep(.l-16px) {
  margin-left: var(--base-16px);
}
</style>
